import React from 'react';
import { HomePageIRUM } from '@/components/HomePage/HomePageIRUM';
import { Box } from '@edreamsodigeo/prisma-design-system';
import { AppHeaderContainer } from '@/components/AppHeader/AppHeaderContainer';
import { PriceFreezeTrackingProvider } from '@/providers/tracking/PriceFreezeTrackingProvider';

export const HomePageMobile = () => {
  return (
    <Box backgroundColor="neutral.20" pb="1x_big">
      <PriceFreezeTrackingProvider page="home_pax">
        <AppHeaderContainer
          customCategory={'pf_summary_details'}
          customPageName={'home_pax'}
        />
        <HomePageIRUM />
      </PriceFreezeTrackingProvider>
    </Box>
  );
};
